
import Vue from 'vue';
import Modal from '~/components/builders/Base/Modal.vue';
import IconBtn from '~/components/builders/IconBtn.vue';

export default Vue.extend({
    name: 'ProfileModal',
    components: {
        Modal,
        IconBtn,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },

        loading: Boolean,
        saveDisabled: Boolean,
        hasUnsavedChanges: Boolean,
    },
    methods: {
        handleClose() {
            if (this.loading) return;

            if (!this.saveDisabled && this.hasUnsavedChanges) {
                const shouldSave = window.confirm(this.$t('profile.closeModal.title').toString());
                if (shouldSave) {
                    this.$emit('save');
                    return;
                }
            }

            this.$emit('close');
        },

        handleSave() {
            if (this.loading) return;
            this.$emit('save');
        },
    },
});
